import dayjs from "dayjs";

// import {
//     v1 as uuidv1,
//     v4 as uuidv4
// } from 'uuid';

// export const uuidVersion = {
//     version1: 1,
//     version2: 2
// }

export function getUniqueProductBarcode() {

    // $current_datetime_string = date("YmdHis"); //14 digit
    // $msecond = microtime();
    // $msecond_string = $msecond * 10000000;
    // $second_str = substr($msecond_string, 0, 6);

    // return $current_datetime_string.$second_str;

    let currentDateTimeString = dayjs().format(`YYYYMMDDHHmmss`)
    let msecond = dayjs().format('SSS')
    let randomNo = (Math.random() * 10000000);
    let secondStr = randomNo.toString().substring(0, 3);

    return `${currentDateTimeString}${msecond}${secondStr}`


}

export function getUniqueProductCodeLong() {

    let currentDateTimeString = dayjs().format(`DDMMHHmmss`)
    let msecond = dayjs().format('SSS')
    // let randomNo = (Math.random() * 10000000);
    // let secondStr = randomNo.toString().substring(0, 3);

    return `${currentDateTimeString}${msecond}`

}

export function getUniqueProductCodeShort() {

    let currentDateTimeString = dayjs().format(`HHmmss`)
    let msecond = dayjs().format('SSS')
    // let randomNo = (Math.random() * 10000000);
    // let secondStr = randomNo.toString().substring(0, 3);

    return `${currentDateTimeString}${msecond}`

}


// export function getUniqueProductBarcode({ version = 1 }) {

//     if (version === 1) return uuidv1()
//     // if(version === 2) return uuid.v2()
//     // if(version === 3) return uuid.v3()
//     if (version === 4) return uuidv4()
//     // if(version === 5) return uuid.v5()

//     // return uuidv4();
//     return "";
// };